// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import UndoOutlinedSvg from "@fishx/icons-svg/es/asn/UndoOutlined";
import FishxIcon from '../components/FishxIcon';

var UndoOutlined = function UndoOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: UndoOutlinedSvg
  }));
};

UndoOutlined.displayName = 'UndoOutlined';
export default React.forwardRef(UndoOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/UndoOutlined.js
// module id = 4301
// module chunks = 0